import script from "./LandingAdvantagesB.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingAdvantagesB.vue?vue&type=script&setup=true&lang=js"

import "./LandingAdvantagesB.vue?vue&type=style&index=0&id=1646c33e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1646c33e"]])

export default __exports__